import { CatalogSection } from './CatalogSection';

export const EducationSection = ({ filterKey }: { filterKey?: string }) => (
  <CatalogSection kind="EDUCATION" filterKey={filterKey} />
);
